import React, { useState, useEffect } from 'react';
import { oneKlicks } from '../../../SDK/oneclick';
import { message, notification, Select } from 'antd';
import { toast } from 'react-toastify';
import { getuserdata } from '../../../services/apiService';
import { OneKlicksFileSDK } from '../../../SDK/OneKlicksFileSDK';
import updateBalance from '../../../Uitiles/updateBalance';
import { debugLog } from '../../../utils/debug';    
const EditExpensesModel = ({ isOpen, toggle, onSubmit, getIncome, fetchIncome }) => {
    debugLog('EditExpensesModel getIncome', getIncome);
    const [expenseType, setExpenseType] = useState(getIncome.category);
    const [transactionType, setTransactionType] = useState(getIncome.transactionType);
    const [errors, setErrors] = useState({});
    const [isUploading, setIsUploading] = useState(false);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [clients, setClients] = useState([]);
    const [loading, setLoading] = useState(false);

    const [expense, setExpense] = useState({
        expenseType: getIncome.expenseType,
        clientId: getIncome.clientId,
        otherDetails: getIncome.otherDetails,
        amount: getIncome.amount,
        date: getIncome.date,
        description: getIncome.description,
        status: getIncome.status,
        notes: getIncome.notes,
        attachments: getIncome.attachments,
        pickupLocation: getIncome.pickupLocation,
        pickupTime: getIncome.pickupTime,
        referenceNumber: getIncome.referenceNumber,
        receipt: getIncome.receipt,
        category: getIncome.category,
        subCategory: getIncome.subCategory,
        clientName: getIncome.clientName,
        campaignDuration: getIncome.campaignDuration,
        providerName: getIncome.providerName,
        websiteLink: getIncome.websiteLink,
        freelancerName: getIncome.freelancerName,
        projectDetails: getIncome.projectDetails,
        purpose: getIncome.purpose,
        utilityType: getIncome.utilityType,
        utilityDetails: getIncome.utilityDetails,
        itemType: getIncome.itemType,
        itemDetails: getIncome.itemDetails,
        todebetaccount: getIncome.todebetaccount
    });

    useEffect(() => {
        const fetchClients = async () => {
            const tableSchema = "";
            const tableName = "users";
            const conditions = {};
            const orderBy = "id DESC";
            const search = {};
            const pagination = {};
            const margedata = [];
            const clients = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
            if (clients.success === true) {
                setClients(clients.data);
            }
            const userid = await getuserdata('id');
            debugLog('userid', userid);
            setExpense(prevIncome => ({
                ...prevIncome,
                todebetaccount: userid
            }));
        };
        fetchClients();
    }, []);

    const filterClients = (clients) => {
        return clients.filter(client => client.user_type === 'administrator' || client.user_type === 'staff' || client.user_type === 'ceo' || client.user_type === 'manager' || client.user_type === 'employee' || client.user_type === 'hr');
    }

    const capitalizeWords = (str) => {
        if (!str) return '';
        return str
            .split(' ')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
            .join(' ');
    };

    const validateForm = () => {
        const newErrors = {};

        if (!expense.category) {
            newErrors.category = 'Category is required';
        }

        if (!expense.amount) {
            newErrors.amount = 'Amount is required';
        } else {
            const cleanAmount = expense.amount.replace(/,/g, '');
            if (isNaN(cleanAmount) || parseFloat(cleanAmount) <= 0) {
                newErrors.amount = 'Amount must be greater than 0';
            }
        }

        if (!expense.date) {
            newErrors.date = 'Date is required';
        }

        if (!transactionType) {
            newErrors.transactionType = 'Transaction type is required';
        }

        if (transactionType === 'cash') {
            if (!expense.pickupLocation) {
                newErrors.pickupLocation = 'Pickup location is required';
            }
            if (!expense.pickupTime) {
                newErrors.pickupTime = 'Pickup time is required';
            }
        }

        if ((transactionType === 'card' || transactionType === 'bank') && !expense.referenceNumber) {
            newErrors.referenceNumber = 'Reference number is required';
        }

        // Category specific validations
        if (expense.category === 'ads') {
            if (!expense.clientName) {
                newErrors.clientName = 'Client name is required';
            }
            if (!expense.campaignDuration) {
                newErrors.campaignDuration = 'Campaign duration is required';
            }
        }

        if (expense.category === 'api') {
            if (!expense.providerName) {
                newErrors.providerName = 'Provider name is required';
            }
            if (!expense.websiteLink) {
                newErrors.websiteLink = 'Website link is required';
            }
        }

        if (expense.category === 'development') {
            if (!expense.freelancerName) {
                newErrors.freelancerName = 'Freelancer name is required';
            }
            if (!expense.projectDetails) {
                newErrors.projectDetails = 'Project details are required';
            }
        }

        if (expense.category === 'utilities') {
            if (!expense.utilityType) {
                newErrors.utilityType = 'Utility type is required';
            }
            if (!expense.utilityDetails) {
                newErrors.utilityDetails = 'Utility details are required';
            }
        }

        if (expense.category === 'physical') {
            if (!expense.itemType) {
                newErrors.itemType = 'Item type is required';
            }
            if (!expense.itemDetails) {
                newErrors.itemDetails = 'Item details are required';
            }
            if (!expense.attachments || expense.attachments.length === 0) {
                newErrors.attachments = 'Receipt/Invoice is required';
            }
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const formatAmount = (value) => {
        // Remove any non-digit characters except decimal point
        const number = value.replace(/[^\d.]/g, '');

        // Split into whole and decimal parts
        const parts = number.split('.');
        const wholePart = parts[0];
        const decimalPart = parts[1] || '';

        // Format whole part with commas
        const formattedWhole = wholePart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

        // Combine with decimal part (max 2 decimal places)
        return decimalPart
            ? `${formattedWhole}.${decimalPart.slice(0, 2)}`
            : formattedWhole;
    };

    const handleInputChange = (e) => {
        const { name, value, files } = e.target;

        if (files) {
            const fileArray = Array.from(files);
            setExpense(prevExpense => ({
                ...prevExpense,
                [name]: fileArray
            }));
        } else {
            // Special handling for amount field
            if (['vendorName', 'clientName', 'providerName', 'freelancerName'].includes(name)) {
                // Capitalize names
                setExpense(prevExpense => ({
                    ...prevExpense,
                    [name]: capitalizeWords(value)
                }));
            } else {
                setExpense(prevExpense => ({
                    ...prevExpense,
                    [name]: value
                }));
            }
        }

        if (errors[name]) {
            setErrors(prev => ({
                ...prev,
                [name]: ''
            }));
        }
    };

    const handleCancel = () => {
        setExpense({
            expenseType: '',
            clientId: '',
            otherDetails: '',
            amount: '',
            date: '',
            description: '',
            status: '',
            notes: '',
            attachments: [],
            pickupLocation: '',
            pickupTime: '',
            referenceNumber: '',
            receipt: null,
            category: '',
            subCategory: '',
            clientName: '',
            campaignDuration: '',
            providerName: '',
            websiteLink: '',
            freelancerName: '',
            projectDetails: '',
            purpose: '',
            utilityType: '',
            utilityDetails: '',
            itemType: '',
            itemDetails: '',
            todebetaccount: ''
        });
        setExpenseType('');
        setTransactionType('');
        setErrors({});
        toggle();
    };

    const handleFileSelect = (e) => {
        const files = Array.from(e.target.files);
        setSelectedFiles(prevFiles => [...prevFiles, ...files]);
        setExpense(prevExpense => ({
            ...prevExpense,
            attachments: [...prevExpense.attachments, ...files]
        }));
    };

    const handleRemoveFile = (index) => {
        setSelectedFiles(prevFiles => prevFiles.filter((_, i) => i !== index));
        setExpense(prevExpense => ({
            ...prevExpense,
            attachments: prevExpense.attachments.filter((_, i) => i !== index)
        }));
    };

    const uploadMultipleFiles = async (files) => {
        const uploadedFileIds = [];
        const root = "expenses";
        const status = "public";

        for (const file of files) {
            try {
                const uploadResult = await OneKlicksFileSDK.uploadFile(root, status, file);
                if (uploadResult && uploadResult.fileId) {
                    uploadedFileIds.push(uploadResult.fileId);
                }
            } catch (error) {
                console.error('Error uploading file:', file.name, error);
                throw new Error(`Failed to upload file: ${file.name}`);
            }
        }

        return uploadedFileIds;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        if (validateForm()) {
            try {
                setIsUploading(true);

                let attachmentIds = [];

                if (expense.attachments && expense.attachments.length > 0) {
                    try {
                        attachmentIds = await uploadMultipleFiles(expense.attachments);
                    } catch (error) {
                        throw new Error(`File upload failed: ${error.message}`);
                    }
                }
                
                const timestamp = new Date().getTime();
                const tableSchema = "";
                const usertype = await getuserdata('user_type');
                const tableName = "expenses";
                const data = {
                    add_by: await getuserdata('id'),
                    title: expense.category === "api" ? expense.providerName : expense.clientName,
                    expenseType: capitalizeWords(expense.expenseType),
                    clientId: expense.clientId,
                    otherDetails: expense.otherDetails,
                    amount: expense.amount.replace(/,/g, ''),
                    date: expense.date,
                    description: capitalizeWords(expense.description),
                    status: usertype === 'administrator' ? "active" : "pending",
                    notes: capitalizeWords(expense.notes),
                    attachments: attachmentIds.join(','),
                    pickupLocation: capitalizeWords(expense.pickupLocation || ""),
                    pickupTime: expense.pickupTime || "",
                    referenceNumber: expense.referenceNumber || "",
                    receipt: expense.receipt || "",
                    transactionType: capitalizeWords(transactionType),
                    category: capitalizeWords(expense.category),
                    subCategory: capitalizeWords(expense.subCategory),
                    clientName: capitalizeWords(expense.clientName || ""),
                    campaignDuration: capitalizeWords(expense.campaignDuration || ""),
                    providerName: capitalizeWords(expense.providerName || ""),
                    websiteLink: expense.websiteLink || "",
                    freelancerName: capitalizeWords(expense.freelancerName || ""),
                    projectDetails: capitalizeWords(expense.projectDetails || ""),
                    purpose: capitalizeWords(expense.purpose || ""),
                    utilityType: capitalizeWords(expense.utilityType || ""),
                    utilityDetails: capitalizeWords(expense.utilityDetails || ""),
                    itemType: capitalizeWords(expense.itemType || ""),
                    itemDetails: capitalizeWords(expense.itemDetails || ""),
                    todebetaccount: expense.todebetaccount || ""
                };

                if (!data.add_by) {
                    throw new Error('User ID not found. Please login again.');
                }

                const conditionnew ={
                    id: getIncome.id
                } 

                // Start transaction
                try {
                    // 1. Create expense record
                    const addExpense = await oneKlicks.update(tableSchema, tableName, data, conditionnew);

                    debugLog('Expense added:', addExpense);
                    
                    if (!addExpense.success) {
                        throw new Error(addExpense.message || 'Failed to add expense');
                    }

                    const updatenewBalance = await updateBalance(data.amount, getIncome.amount, data.todebetaccount, getIncome.transaction_id, data, '-');

                    debugLog('updatenewBalance', updatenewBalance);
                    message.success("Expense added successfully");
                    toast.success("Expense added successfully");

                    if (typeof onSubmit === 'function') {
                        onSubmit(expense);
                    }
                    getIncome();
                    handleCancel();

                } catch (error) {
                    // If any step fails, we should rollback the changes
                    // Note: This would require implementing rollback functionality in your SDK
                    throw new Error(`Transaction failed: ${error.message}`);
                }

            } catch (error) {
                console.error('Error adding expense:', error);
                message.error(error.message || 'An error occurred while adding expense');
                toast.error(error.message || 'An error occurred while adding expense');
            } finally {
                setIsUploading(false);
                setLoading(false);
                fetchIncome();
            }
        } else {
            setLoading(false);
        }
    };

    return (
        <div className="modal fade dc-loginformpop show" style={{ display: 'block', paddingRight: '17px', background: '#00000085' }} aria-modal="true" role="dialog">
            <div className="modal-dialog modal-dialog-centered" role="document" style={{ width: '50%', maxWidth: '500px' }}>
                <div className="dc-modalcontent modal-content">
                    <div className="dc-loginformholds" style={{ maxHeight: '80vh', overflowY: 'auto' }}>
                        <div className="dc-loginheader" style={{ paddingLeft: '0px' }}>
                            <span style={{ fontSize: '20px', fontWeight: 'bold' }}>Edit Expense</span>
                            <a href="#" className="dc-closebtns close dc-close" onClick={handleCancel} aria-label="Close">
                                <i className="fa fa-times"></i>
                            </a>
                        </div>
                        <form onSubmit={handleSubmit} className="dc-html-form" style={{ marginTop: 24 }}>
                            <div className="form-group">
                                <label htmlFor="category"><span style={{ color: 'red' }}>*</span> Category</label>
                                <select
                                    id="category"
                                    name="category"
                                    className={`dc-form-control ${errors.category ? 'is-invalid' : ''}`}
                                    required
                                    value={expense.category || getIncome.category}
                                    onChange={handleInputChange}
                                >
                                    <option value="">Select category</option>
                                    <option value="Ads">Ads Spending</option>
                                    <option value="Api">APIs</option>
                                    <option value="Development">Development</option>
                                    <option value="Marketing">Marketing</option>
                                    <option value="Utilities">Utilities</option>
                                    <option value="Physical">Physical Items/Systems</option>
                                    <option value="Other">Other</option>
                                </select>
                                {errors.category && <div className="invalid-feedback">{errors.category}</div>}
                            </div>

                            {expense.category === 'ads' && (
                                <>
                                    <div className="form-group">
                                        <label htmlFor="subCategory"><span style={{ color: 'red' }}>*</span> Ad Platform</label>
                                        <select
                                            id="subCategory"
                                            name="subCategory"
                                            className="dc-form-control"
                                            required
                                            value={expense.subCategory}
                                            onChange={handleInputChange}
                                        >
                                            <option value="">Select platform</option>
                                            <option value="google">Google Ads</option>
                                            <option value="facebook">Facebook Ads</option>
                                            <option value="instagram">Instagram Ads</option>
                                            <option value="linkedin">LinkedIn Ads</option>
                                            <option value="other">Other</option>
                                        </select>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="clientName"><span style={{ color: 'red' }}>*</span> Client Name</label>
                                        <input
                                            type="text"
                                            id="clientName"
                                            name="clientName"
                                            className="dc-form-control"
                                            required
                                            placeholder="Enter client name"
                                            value={expense.clientName}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="campaignDuration"><span style={{ color: 'red' }}>*</span> Campaign Duration</label>
                                        <input
                                            type="text"
                                            id="campaignDuration"
                                            name="campaignDuration"
                                            className="dc-form-control"
                                            required
                                            placeholder="Enter campaign duration"
                                            value={expense.campaignDuration}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                </>
                            )}

                            {expense.category === 'api' && (
                                <>
                                    <div className="form-group">
                                        <label htmlFor="subCategory"><span style={{ color: 'red' }}>*</span> API Type</label>
                                        <select
                                            id="subCategory"
                                            name="subCategory"
                                            className="dc-form-control"
                                            required
                                            value={expense.subCategory}
                                            onChange={handleInputChange}
                                        >
                                            <option value="">Select API type</option>
                                            <option value="payment">Payment Gateway</option>
                                            <option value="sms">SMS Gateway</option>
                                            <option value="email">Email Service</option>
                                            <option value="maps">Maps Service</option>
                                            <option value="other">Other</option>
                                        </select>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="providerName"><span style={{ color: 'red' }}>*</span> Provider Name</label>
                                        <input
                                            type="text"
                                            id="providerName"
                                            name="providerName"
                                            className="dc-form-control"
                                            required
                                            placeholder="Enter API provider name"
                                            value={expense.providerName}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="websiteLink"><span style={{ color: 'red' }}>*</span> Website Link</label>
                                        <input
                                            type="url"
                                            id="websiteLink"
                                            name="websiteLink"
                                            className="dc-form-control"
                                            required
                                            placeholder="Enter provider website link"
                                            value={expense.websiteLink}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                </>
                            )}

                            {expense.category === 'development' && (
                                <>
                                    <div className="form-group">
                                        <label htmlFor="freelancerName"><span style={{ color: 'red' }}>*</span> Freelancer Name</label>
                                        <input
                                            type="text"
                                            id="freelancerName"
                                            name="freelancerName"
                                            className="dc-form-control"
                                            required
                                            placeholder="Enter freelancer name"
                                            value={expense.freelancerName}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="projectDetails"><span style={{ color: 'red' }}>*</span> Project Details</label>
                                        <textarea
                                            id="projectDetails"
                                            name="projectDetails"
                                            className="dc-form-control"
                                            required
                                            rows="4"
                                            placeholder="Enter project details"
                                            value={expense.projectDetails}
                                            onChange={handleInputChange}
                                        ></textarea>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="purpose"><span style={{ color: 'red' }}>*</span> Purpose</label>
                                        <textarea
                                            id="purpose"
                                            name="purpose"
                                            className="dc-form-control"
                                            required
                                            rows="4"
                                            placeholder="Enter purpose of development"
                                            value={expense.purpose}
                                            onChange={handleInputChange}
                                        ></textarea>
                                    </div>
                                </>
                            )}

                            {expense.category === 'utilities' && (
                                <>
                                    <div className="form-group">
                                        <label htmlFor="utilityType"><span style={{ color: 'red' }}>*</span> Utility Type</label>
                                        <select
                                            id="utilityType"
                                            name="utilityType"
                                            className="dc-form-control"
                                            required
                                            value={expense.utilityType}
                                            onChange={handleInputChange}
                                        >
                                            <option value="">Select utility type</option>
                                            <option value="electricity">Electricity</option>
                                            <option value="water">Water</option>
                                            <option value="internet">Internet</option>
                                            <option value="phone">Phone</option>
                                            <option value="other">Other</option>
                                        </select>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="utilityDetails"><span style={{ color: 'red' }}>*</span> Utility Details</label>
                                        <textarea
                                            id="utilityDetails"
                                            name="utilityDetails"
                                            className="dc-form-control"
                                            required
                                            rows="4"
                                            placeholder="Enter utility details"
                                            value={expense.utilityDetails}
                                            onChange={handleInputChange}
                                        ></textarea>
                                    </div>
                                </>
                            )}

                            {expense.category === 'physical' && (
                                <>
                                    <div className="form-group">
                                        <label htmlFor="itemType"><span style={{ color: 'red' }}>*</span> Item Type</label>
                                        <select
                                            id="itemType"
                                            name="itemType"
                                            className="dc-form-control"
                                            required
                                            value={expense.itemType}
                                            onChange={handleInputChange}
                                        >
                                            <option value="">Select item type</option>
                                            <option value="computer">Computer/System</option>
                                            <option value="printer">Printer</option>
                                            <option value="furniture">Furniture</option>
                                            <option value="equipment">Equipment</option>
                                            <option value="other">Other</option>
                                        </select>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="itemDetails"><span style={{ color: 'red' }}>*</span> Item Details</label>
                                        <textarea
                                            id="itemDetails"
                                            name="itemDetails"
                                            className="dc-form-control"
                                            required
                                            rows="4"
                                            placeholder="Enter item details and specifications"
                                            value={expense.itemDetails}
                                            onChange={handleInputChange}
                                        ></textarea>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="attachments"><span style={{ color: 'red' }}>*</span> Receipt/Invoice</label>
                                        <input
                                            type="file"
                                            id="attachments"
                                            name="attachments"
                                            className="dc-form-control"
                                            required
                                            onChange={handleFileSelect}
                                            accept="image/*,.pdf"
                                        />
                                        <small className="form-text text-muted">Please upload receipt or invoice (PDF or image)</small>
                                        {selectedFiles.length > 0 && (
                                            <div className="mt-3">
                                                <h6>Selected Files:</h6>
                                                <div className="selected-files-list">
                                                    {selectedFiles.map((file, index) => (
                                                        <div key={index} className="selected-file-item" style={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'space-between',
                                                            padding: '8px',
                                                            margin: '4px 0',
                                                            backgroundColor: '#f8f9fa',
                                                            borderRadius: '4px'
                                                        }}>
                                                            <span style={{ flex: 1 }}>{file.name}</span>
                                                            <button
                                                                type="button"
                                                                onClick={() => handleRemoveFile(index)}
                                                                className="btn btn-sm btn-danger"
                                                                style={{ marginLeft: '8px' }}
                                                            >
                                                                <i className="fa fa-times"></i>
                                                            </button>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </>
                            )}



                            <div className="form-group">
                                <label htmlFor="date"><span style={{ color: 'red' }}>*</span> Date</label>
                                <input
                                    type="date"
                                    id="date"
                                    name="date"
                                    className={`dc-form-control ${errors.date ? 'is-invalid' : ''}`}
                                    required
                                    value={expense.date}
                                    onChange={handleInputChange}
                                />
                                {errors.date && <div className="invalid-feedback">{errors.date}</div>}
                            </div>

                            <div className="form-group">
                                <label htmlFor="transactionType"><span style={{ color: 'red' }}>*</span> Transaction Type</label>
                                <select
                                    id="transactionType"
                                    name="transactionType"
                                    className={`dc-form-control ${errors.transactionType ? 'is-invalid' : ''}`}
                                    required
                                    value={transactionType}
                                    onChange={(e) => {
                                        setTransactionType(e.target.value);
                                        handleInputChange(e);
                                    }}
                                >
                                    <option value="">Select transaction type</option>
                                    <option value="Cash">Cash</option>
                                    <option value="Card">Card</option>
                                    <option value="Bank">Bank Transfer</option>
                                    <option value="Upi">UPI</option>
                                </select>
                                {errors.transactionType && <div className="invalid-feedback">{errors.transactionType}</div>}
                            </div>

                            {transactionType === 'cash' && (
                                <>
                                    <div className="form-group">
                                        <label htmlFor="pickupLocation"><span style={{ color: 'red' }}>*</span> Cash Pickup Location</label>
                                        <input
                                            type="text"
                                            id="pickupLocation"
                                            name="pickupLocation"
                                            className={`dc-form-control ${errors.pickupLocation ? 'is-invalid' : ''}`}
                                            required
                                            placeholder="Enter cash pickup location"
                                            value={expense.pickupLocation}
                                            onChange={handleInputChange}
                                        />
                                        {errors.pickupLocation && <div className="invalid-feedback">{errors.pickupLocation}</div>}
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="pickupTime"><span style={{ color: 'red' }}>*</span> Pickup Time</label>
                                        <input
                                            type="datetime-local"
                                            id="pickupTime"
                                            name="pickupTime"
                                            className={`dc-form-control ${errors.pickupTime ? 'is-invalid' : ''}`}
                                            required
                                            value={expense.pickupTime}
                                            onChange={handleInputChange}
                                        />
                                        {errors.pickupTime && <div className="invalid-feedback">{errors.pickupTime}</div>}
                                    </div>
                                </>
                            )}

                            {(transactionType === 'card' || transactionType === 'bank') && (
                                <>
                                    <div className="form-group">
                                        <label htmlFor="referenceNumber"><span style={{ color: 'red' }}>*</span> Reference Number</label>
                                        <input
                                            type="text"
                                            id="referenceNumber"
                                            name="referenceNumber"
                                            className={`dc-form-control ${errors.referenceNumber ? 'is-invalid' : ''}`}
                                            required
                                            placeholder="Enter reference number"
                                            value={expense.referenceNumber}
                                            onChange={handleInputChange}
                                        />
                                        {errors.referenceNumber && <div className="invalid-feedback">{errors.referenceNumber}</div>}
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="attachments">Attachments</label>
                                        <input
                                            type="file"
                                            id="attachments"
                                            name="attachments"
                                            className="dc-form-control"
                                            multiple
                                            onChange={handleFileSelect}
                                            accept="image/*,.pdf,.doc,.docx,.xls,.xlsx"
                                        />
                                        {selectedFiles.length > 0 && (
                                            <div className="mt-3">
                                                <h6>Selected Files:</h6>
                                                <div className="selected-files-list">
                                                    {selectedFiles.map((file, index) => (
                                                        <div key={index} className="selected-file-item" style={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'space-between',
                                                            padding: '8px',
                                                            margin: '4px 0',
                                                            backgroundColor: '#f8f9fa',
                                                            borderRadius: '4px'
                                                        }}>
                                                            <span style={{ flex: 1 }}>{file.name}</span>
                                                            <button
                                                                type="button"
                                                                onClick={() => handleRemoveFile(index)}
                                                                className="btn btn-sm btn-danger"
                                                                style={{ marginLeft: '8px' }}
                                                            >
                                                                <i className="fa fa-times"></i>
                                                            </button>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </>
                            )}

                            <div className="form-group">
                                <label htmlFor="amount"><span style={{ color: 'red' }}>*</span> Amount</label>
                                <div className="input-group">
                                    <span className="input-group-text" style={{ width: '50px' }}>₹</span>
                                    <input
                                        type="text"
                                        id="amount"
                                        name="amount"
                                        className={`dc-form-control ${errors.amount ? 'is-invalid' : ''}`}
                                        placeholder="0.00"
                                        required
                                        value={expense.amount}
                                        onChange={handleInputChange}
                                        style={{ flex: 1 }}
                                    />
                                </div>
                                {errors.amount && <div className="invalid-feedback">{errors.amount}</div>}
                            </div>

                            <div className="form-group">
                                <label htmlFor="description"><span style={{ color: 'red' }}>*</span>To Debet Account</label>
                                <Select
                                    id="todebetaccount"
                                    name="todebetaccount"
                                    className={`${errors.todebetaccount ? 'is-invalid' : ''}`}
                                    placeholder="Select a Client"
                                    value={expense.todebetaccount || undefined}
                                    onChange={(value) => {
                                        setExpense(prev => ({
                                            ...prev,
                                            todebetaccount: value
                                        }));
                                        if (errors.todebetaccount) {
                                            setErrors(prev => ({
                                                ...prev,
                                                todebetaccount: ''
                                            }));
                                        }
                                    }}
                                    options={[
                                        { value: '0', label: 'MeddyList Account' },
                                        ...filterClients(clients).map(client => ({
                                            value: client.id,
                                            label: `${client.display_name} - ${client.email}`
                                        }))
                                    ]}
                                    showSearch
                                    filterOption={(input, option) =>
                                        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                    }
                                    style={{
                                        width: '100%',
                                        color: '#000000',
                                        backgroundColor: '#ffffff',
                                        height: '44px',
                                        borderColor: '#4e5779',
                                        boxShadow: 'none',
                                        borderRadius: '4px'
                                    }}
                                />
                                {errors.todebetaccount && <div className="invalid-feedback">{errors.todebetaccount}</div>}
                            </div>

                            <div className="form-group">
                                <label htmlFor="description">Description</label>
                                <textarea
                                    id="description"
                                    name="description"
                                    className="dc-form-control"
                                    rows="4"
                                    placeholder="Enter expense description"
                                    value={expense.description}
                                    onChange={handleInputChange}
                                ></textarea>
                            </div>

                            <div className="form-group">
                                <label htmlFor="notes">Notes</label>
                                <textarea
                                    id="notes"
                                    name="notes"
                                    className="dc-form-control"
                                    rows="4"
                                    placeholder="Enter any additional notes"
                                    value={expense.notes}
                                    onChange={handleInputChange}
                                ></textarea>
                            </div>

                            <div className="form-group">
                                <button
                                    type="submit"
                                    className="dc-btn dc-update-servicess"
                                    style={{ width: '100%' }}
                                    disabled={isUploading || loading}
                                >
                                    {isUploading || loading ? 'Uploading...' : 'Add Expense'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

const customStyles = {
    control: (provided) => ({
        ...provided,
        minHeight: '44px',
        maxHeight: '44px',
        width: '100%',
        minWidth: '200px',
        borderColor: '#4e5779',
        boxShadow: 'none',
        backgroundColor: '#ffffff',
        '&:hover': {
            borderColor: '#4e5779'
        }
    }),
    input: (provided) => ({
        ...provided,
        color: '#000000',
        margin: '0px'
    }),
    singleValue: (provided) => ({
        ...provided,
        color: '#000000'
    }),
    placeholder: (provided) => ({
        ...provided,
        color: '#666666',
        margin: '0px'
    }),
    menu: (provided) => ({
        ...provided,
        zIndex: 9999,
        backgroundColor: '#ffffff'
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected ? '#4e5779' : '#ffffff',
        color: state.isSelected ? '#ffffff' : '#000000',
        '&:hover': {
            backgroundColor: '#4e5779',
            color: '#ffffff'
        }
    })
};

export default EditExpensesModel;

